import { InformationCircleIcon } from "@heroicons/react/24/outline";
import ReactTooltip from "react-tooltip";
import { useEffect } from "react";
import { LoaderSpinner } from "./LoaderSpinner";
import { formatDateByGMT } from "../helpers/formatDateByGMT";
import { reworkDate } from "../helpers/common";

const getTokenColor = (status) => {
    switch (status) {
      case "EXPIRED":
          return 'text-red-600';
      case "SUCCESS":
          return 'text-green-600';
      default:
          return 'text-gray-600';
    }
}

const getTokenStatus = (date) => {
    if (!date) return "";
    const currentDate = new Date();
    const targetDate = new Date(reworkDate(date));
    const result = currentDate < targetDate ? "SUCCESS" : "EXPIRED";
    return result;
}

export const QuickBooksUpdatesBlock = ({
    redirectRequestFunction,
    refreshTokenFunction,
    expiredRefreshTokenDate,
    errorTextRefreshToken,
    expiredAccessTokenDate,
    errorTextAccessToken,
    isLoading,
    isFirstLoading,
    testId
}) => {
    useEffect(() => {
        ReactTooltip.rebuild()
    }, [])
    const refreshTokenStatus = getTokenStatus(expiredRefreshTokenDate);
    return (
        <section className="bg-white p-2 rounded-lg shadow w-auto max-w-56" data-testid={testId}>
          <div className="flex gap-2 text-base items-center justify-center">
            {isFirstLoading || isLoading ? (
                <div className="min-w-[220px] my-2">
                    <LoaderSpinner border="2" width="12" height="12" colorSpinner="black" type="cron" testId={`loader-spinner-${testId}`}/>
                </div>
            ) : (
                <div className="flex gap-2 items-center">
                    <button 
                        className="text-white bg-blue-700 font-medium rounded-lg text-sm px-2 py-1 whitespace-nowrap"
                        data-testid={`button-${testId}`}
                        onClick={() => redirectRequestFunction?.()}
                    >
                        {`${refreshTokenStatus === "SUCCESS" ? 'Reconnect' : 'Connect'} to QuickBooks`}
                    </button>
                    <InformationCircleIcon 
                        className={`h-5 w-5 text-black-600 hover:text-black-900 ${getTokenColor(refreshTokenStatus)}`}
                        data-for='tooltip-quick-books'
                        data-tip={true}
                        data-testid={`icon-${testId}`}
                    />
                    <ReactTooltip 
                        id={'tooltip-quick-books'} 
                        html={true}
                        effect='solid'
                    >
                        {`
                            <div class="w-72">
                                <div>Refresh token:</div>
                                <div>Expiration date ${expiredRefreshTokenDate ? formatDateByGMT(expiredRefreshTokenDate) : "N/A"}</div>
                                ${errorTextRefreshToken ? `<div>Error: ${errorTextRefreshToken}</div>` : ""}
                                <div>Access token:</div>
                                <div>Expiration date ${expiredAccessTokenDate ? formatDateByGMT(expiredAccessTokenDate) : "N/A"}</div>
                                ${errorTextAccessToken ? `<div>Error: ${errorTextAccessToken}</div>` : ""}
                            </div>
                        `}
                    </ReactTooltip>
                </div>
            )}
          </div>
        </section>
    )
}